// Banner bovenaan de app zodra de browser offline is.
// Gebruikt @rvdh/react-hooks useOnlineStatus (window online/offline-events).

import React from 'react';
import { Alert, Collapse } from '@mui/material';
import { useOnlineStatus } from '@rvdh/react-hooks';
import { useTranslation } from 'react-i18next';

export default function OfflineBanner() {
    const isOnline = useOnlineStatus();
    const { t } = useTranslation();

    return (
        <Collapse in={!isOnline} unmountOnExit>
            <Alert
                severity="warning"
                variant="filled"
                sx={{ borderRadius: 0, justifyContent: 'center' }}
            >
                {t('offline.banner')}
            </Alert>
        </Collapse>
    );
}
